// 对讲mediasoup 文件
import { Device } from 'mediasoup-client'
import { WebSocketTransport, Peer } from 'protoo-client'
import { CHAT, websocketapp } from '@/common/websocket/index'
import { getSession } from '@/api/common'
import store from '@/store/index'

// websocket 是否连接成功
let g_is_login = false

let _closed = false

// Display name.
// @type {String}
// 初始化房间号
let _peerId = 'web' + uuid()

let _peerName = '管理员' + randomNumstr(4)
console.log(`_peerId:${_peerId} _peerName:${_peerName}`)

//当前所有peers
let _peers = {}

// Device info.
// @type {Object}
let _device = {}

// Whether we want to force RTC over TCP.
// @type {Boolean}
let _forceTcp = false

// protoo-client Peer instance.
// @type {protooClient.Peer}
let _peer = null

// mediasoup-client Device instance.
// @type {mediasoupClient.Device}
let _mediasoupDevice = null

// mediasoup Consumers.
// @type {Map<String, mediasoupClient.Consumer>}
let _consumers = new Map()

// Local mic mediasoup Producer.
// @type {mediasoupClient.Producer}
let _micProducer = null

// 当前的房间号
let roomId = null

//房间是否在进行中
var g_is_meeting = false
// 已经消费的producerId
var consumeredProduIds = new Set()

// 是否有麦克风设备
let hasMic = false
let allUser = []

/**
 * websocket与视频平台建立连接
 */
async function loginWalkie() {
  await checkMic()
  let url = store.getters.mediasoupWsUrl
  // console.log(url, url + '?peerId=' + _peerId + '&peerName=' + _peerName)
  var transport = new WebSocketTransport(url + '?peerId=' + _peerId + '&peerName=' + _peerName)
  _peer = new Peer(transport)
  _peer.on('open', () => {
    getRooms()
  })

  // failed、disconnected将触发重连事件，重连10次，不成功则触发close事件
  _peer.on('failed', () => {
    g_is_login = false
    console.error('MVCP websocket 连接失败！', g_is_login)
  })

  // 监听服务端发送的请求
  _peer.on('request', async (request, accept) => {
    console.debug('proto "request" event [method:%s, data:%o]', request.method, request.data)

    switch (request.method) {
      // 断线(被占用)
      case 'peerClose': {
        // warning('该账号已从另一设备登陆')
        _peer.close()
        break
      }
      // 接收到自定义消息
      case 'routerMsg': {
        const routerMsg = request.data
        if (routerMsg.cmd) {
          console.error('unknown protoo routerMsg.cmd "%s"', routerMsg.cmd)
        }
        accept()
        break
      }
      default: {
        console.error('unknown protoo request.method "%s"', request.method)
      }
    }
  })

  //通知
  _peer.on('notification', notification => {
    // console.log(notification,'delayTime')
    switch (notification.method) {
      // 生产者分数
      case 'producerScore': {
        break
      }
      // 有新的消费者
      case 'newConsumer': {
        try {
          // 处理新消费者
          console.log('newConsumer处理新消费者', roomId)
          getRoomPeers()
        } catch (error) {
          console.error('"newConsumer" request failed:%o', error)
          throw error
        }
        break
      }
      // 新用户加入房间
      case 'roomPeerJoin': {
        break
      }
      // 用户离开房间
      case 'roomPeerLeave': {
        console.log('roomPeerLeave', notification.data)
        getRoomPeers()
        break
      }
      // 下行带宽评估的通知
      case 'downlinkBwe': {
        break
      }
      // 消费者关闭（生产者关闭）
      case 'consumerClosed': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        // 关闭
        consumer.close()
        // 从消费者列表删除
        _consumers.delete(consumerId)
        break
      }
      // 消费者暂停消费（生产者暂停）
      case 'consumerPaused': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        consumer.pause()
        break
      }
      // 消费者恢复消费
      case 'consumerResumed': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        consumer.resume()
        break
      }
      // 消费者（视频）层级变更的通知（需开启simulcast）
      case 'consumerLayersChanged': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        break
      }
      // 消费者分数
      case 'consumerScore': {
        break
      }
      // 会议当前发言人
      case 'activeSpeaker': {
        // 正常 'activeSpeaker'不回执行
        break
      }
      default: {
        console.error('unknown protoo notification.method "%s"', notification.method)
      }
    }
  })
}

/**
 * 获取在线房间信息
 */
async function getRooms() {
  try {
    const { rooms } = await _peer.request('getRooms')
    for (var j = 0; j < rooms.length; j++) {
      if (roomId === rooms[j].id) {
        // 如果房间号重复，则重新生成房间号
        roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
        for (var k = 0; k < 6; k++) roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
      }
    }
    console.log('获取在线房间信息')
    g_is_login = true
  } catch (error) {
    console.error('获取在线房间信息异常' + error)
  }
}

/**
 * 加入房间
 * @param {String} roomId 房间号
 */
async function joinRoomSoup(roomId) {
  console.log('加入房间:', roomId)
  // leaveRoomSelf()
  if (!_peer._connected && !_closed && getSession('access_token')) {
    // 易造成发送两条join请求
    setTimeout(() => {
      joinRoomSoup(roomId)
    }, 300)
  } else {
    // 加入房间
    await _peer.request('join', {
      roomId: roomId,
      device: _device,
    })

    g_is_meeting = true
    _mediasoupDevice = new Device()

    _closed = false

    const routerRtpCapabilities = await _peer.request('getRouterRtpCapabilities')

    // 使用mediasoup路由器的RTP功能加载设备。这就是设备如何知道允许的媒体编解码器和其他设置
    await _mediasoupDevice.load({ routerRtpCapabilities })

    // 创建媒体生产者
    await _produceMedia()
  }
}

let _sendTransport
// 创建媒体生产者
async function _produceMedia() {
  try {
    // 服务器创建transport
    const transportInfo = await _peer.request('createWebRtcTransport', {
      forceTcp: _forceTcp,
    })
    const { id, iceParameters, iceCandidates, dtlsParameters } = transportInfo

    // 本地创建sendTransport
    _sendTransport = _mediasoupDevice.createSendTransport({
      id,
      iceParameters,
      iceCandidates,
      dtlsParameters,
      iceServers: [],
      proprietaryConstraints: {
        optional: [{ googDscp: true }],
      },
    })

    // 监听connect，当produce调用时连接
    _sendTransport.on(
      'connect',
      (
        { dtlsParameters },
        callback,
        errback // eslint-disable-line no-shadow
      ) => {
        _peer
          .request('connectWebRtcTransport', {
            transportId: _sendTransport.id,
            dtlsParameters,
          })
          .then(callback)
          .catch(errback)
      }
    )

    // 监听produce，得到id，用于创建本地producer
    _sendTransport.on('produce', ({ kind, rtpParameters }, callback, errback) => {
      try {
        // eslint-disable-next-line no-shadow
        const { id } = _peer.request('produce', {
          transportId: _sendTransport.id,
          kind,
          rtpParameters,
        })

        callback({ id })
      } catch (error) {
        errback(error)
      }
    })

    _sendTransport.on('connectionstatechange', connectionState => {
      try {
        if (connectionState === 'disconnected') {
          if (_sendTransport) {
            _sendTransport.close()
          }
        }
      } catch (error) {
        console.error('连接已断开，请重新连接')
      }
    })

    // 开启麦克风
    await enableMic()
  } catch (error) {
    console.error('发送音视频失败', error)
  }
}

let _recvTransport
// 创建媒体消费者
async function _consumeMedia() {
  try {
    // 服务端创建transport
    const transportInfo = await _peer.request('createWebRtcTransport', {
      forceTcp: _forceTcp,
    })

    const { id, iceParameters, iceCandidates, dtlsParameters } = transportInfo

    // 客户端创建recvTransport
    _recvTransport = _mediasoupDevice.createRecvTransport({
      id,
      iceParameters,
      iceCandidates,
      dtlsParameters,
      iceServers: [],
    })

    // 调用consume时connect
    _recvTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
      _peer
        .request('connectWebRtcTransport', {
          transportId: _recvTransport.id,
          dtlsParameters,
        })
        .then(callback)
        .catch(errback)
    })
    _recvTransport.on('connectionstatechange', connectionState => {
      try {
        if (connectionState === 'disconnected') {
          // Close mediasoup Transports.
          if (_sendTransport) _sendTransport.close()

          if (_recvTransport) _recvTransport.close()
        }
      } catch (error) {
        console.error('连接已断开，请重新连接:transport disconnected %o', error)
      }
    })
  } catch (error) {
    console.error('订阅音视频失败:_consumeMedia failed:%o', error)
  }
}

// 订阅流
async function _getConsume(peerId, _producerId) {
  console.log(peerId, _producerId, 'peerId, _producerId')
  try {
    // 服务端订阅流
    let consume = await _peer.request('consume', {
      transportId: _recvTransport.id,
      peerId,
      producerId: _producerId,
      rtpParameters: _mediasoupDevice.rtpCapabilities,
    })
    const { id, kind, producerId, producerPaused, rtpParameters } = consume
    // 只订阅当前观看设备的流
    if (peerId.indexOf('web') === -1 && !consumeredProduIds.has(_producerId)) {
      // 本地订阅流
      _transportConsume({
        peerId: peerId,
        producerId,
        id,
        kind,
        producerPaused,
        rtpParameters,
      })
      consumeredProduIds.add(_producerId)
    }
  } catch (error) {
    console.error('订阅音视频流失败', error)
  }
}

// 本地订阅流
async function _transportConsume({ peerId, producerId, id, kind, type, producerPaused, rtpParameters }) {
  const consumer = await _recvTransport.consume({
    id,
    producerId,
    kind,
    rtpParameters,
  })
  _consumers.set(consumer.id, consumer)
  consumer.on('transportclose', () => {
    _consumers.delete(consumer.id)
  })
  // 根据webrtc-svc中的规则解析给定的scalabilityMode字符串。
  // const { spatialLayers, temporalLayers } = parseScalabilityMode(consumer.rtpParameters.encodings[0].scalabilityMode)
  console.log('consumer.track', consumer.track)
  if (consumer.track.kind === 'audio') {
    var audioElm = null
    audioElm = document.getElementById('walkieDom')
    const stream = new MediaStream()
    console.log('加载音频流：' + consumer.track.id)
    stream.addTrack(consumer.track)

    audioElm.srcObject = stream
    unmuteMic('音频流')
    console.log('audioElm', audioElm, audioElm.srcObject)
  }
}
/**
 * 解除静音（恢复生产流）
 */
async function unmuteMic(type) {
  console.log('_micProducer', _micProducer)
  if (!_micProducer) {
    // 创建媒体生产者
    await _produceMedia()
    return
  }
  // console.log('重新打开transport',_micProducer)

  _micProducer.resume()

  try {
    let mvcpAudio = document.getElementById('walkieDom')
    console.log('解除静音（恢复生产流）', mvcpAudio, type)
    if (mvcpAudio) {
      mvcpAudio.play()
    }
    if (_micProducer.id) {
      await _peer.request('resumeProducer', {
        producerId: _micProducer.id,
      })
    }
  } catch (error) {
    console.error('取消静音异常', error)
  }
}
/**
 * 检查是否是否有麦克风，若没有，则直接返回
 */
async function checkMic() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true })
    hasMic = true
  } catch (error) {
    if (error.message === 'Requested device not found') {
      console.error('您的计算机未找到麦克风设备')
    } else {
      console.error('checkMic error', error)
    }
    hasMic = false
  }
}
// 开启麦克风
async function enableMic() {
  console.log('开启麦克风', _micProducer, !hasMic)

  //判断后台是否有麦克风，若没有，则直接返回
  if (!hasMic) {
    return
  }
  if (!_mediasoupDevice.canProduce('audio')) {
    console.error('enableMic() | cannot produce audio')
    return
  }

  let track
  try {
    // 获取音频流
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    track = stream.getAudioTracks()[0]

    // 创建producer
    _micProducer = await _sendTransport.produce({
      track,
      codecOptions: {
        opusStereo: 1,
        opusDtx: 1,
      },
    })
    unmuteMic('麦克风')
    console.log('_micProducer', _micProducer, _micProducer._track.id)

    _micProducer.on('transportclose', () => {
      console.log('清空_micProducer')
      _micProducer = null
    })

    _micProducer.on('trackended', () => {
      console.error('麦克风断开连接!')
      // 关闭producer
      disableMic().catch(() => {})
    })
  } catch (error) {
    console.error('enableMic() | failed:%o', error)
    if (track) track.stop()
  }
}

// 关闭麦克风
async function disableMic() {
  console.debug('关闭麦克风disableMic()')

  if (!_micProducer) return

  // 本地关闭
  _micProducer.close()

  try {
    // 服务器关闭
    await _peer.request('closeProducer', {
      producerId: _micProducer.id,
    })
  } catch (e) {
    console.log(e)
  }

  _micProducer = null
}

let roomPeers
/**
 * 获取房间用户信息
 */
async function getRoomPeers() {
  console.log('getRoomPeers', roomId)

  try {
    roomPeers = await _peer.request('getRoomPeers')

    console.debug(`roomPeers:${JSON.stringify(roomPeers)}`)
    console.log('roomPeers.roomPeers:', roomPeers.roomPeers)
    await _consumeMedia()
    for (const roomPeer of roomPeers.roomPeers) {
      if (roomPeer.id !== _peerId) {
        // 获取房间用户生产者
        const { producers } = roomPeer
        producers.forEach(producer => {
          // 为每个生产者创建消费通道
          if (roomPeer.id.indexOf('web') !== 0) {
            console.log('为每个生产者创建消费通道')
            _getConsume(roomPeer.id, producer.id)
          }
        })
      }
    }
  } catch (error) {
    console.error('获取房间用户信息失败:' + error)
  }
}

/**
 * 获取所有在线用户
 */
async function getPeers() {
  try {
    const { peers } = await _peer.request('getPeers')
    _peers = peers
    console.log('获取在线用户', _peers)
  } catch (error) {
    loginWalkie()
    console.error('获取在线用户失败', error)
  }
}

/**
 * 离开房间
 */
async function closeResetMeet() {
  try {
    console.log('离开房间')
    await _peer.request('leave')
    g_is_meeting = false
    store.commit('openWaike', false)
  } catch (error) {
    console.log(error)
  }
}

/**
 * 工具代码类
 */

//生成随机peerId
function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

// 生成随机数字符串
function randomNumstr(length) {
  if (typeof length != 'number') {
    length = 4
  }
  var numStr = Math.floor(Math.random() * 10) + 1 + ''
  for (var i = 1; i < length; i++) {
    numStr += Math.floor(Math.random() * 10)
  }
  return numStr
}

/**
 * 业务代码
 */
if (
  getSession('access_token') &&
  store.getters.rtcType === 'mediasoup' &&
  !window.location.href.includes('Intercom') &&
  !window.location.href.includes('realvideo') &&
  !window.location.href.includes('/externalHistory')
) {
  console.log('appMvcp对讲', _peers)
  loginWalkie()
}
// 退出实行关闭
function outClose() {
  if (_peers) {
    _consumers.forEach(function(consu) {
      consu.close()
    })
    _consumers.clear()
    consumeredProduIds.clear()
    _micProducer = null
    if (_peer) _peer.close()
  }
}

/**
 * 加入对讲
 * @param {*} helmetList 单个或多个头盔序列号
 * @param {*} roomId 房间id
 */
async function helmetJoinSoup(helmetList, roomId) {
  allUser = helmetList
  let preNum = randomNumstr(4)
  let nextNum = new Date().getTime() + ''
  nextNum = nextNum.substr(nextNum.length - 4)
  roomId = preNum + nextNum
  console.log('helmetJoinSoup加入对讲', _peer)
  if (!_peer._connected && !_closed) {
    // 易造成发送两条join请求
    loginWalkie()
    setTimeout(() => {
      helmetJoinSoup(allUser, roomId)
    }, 3000)
  } else {
    await getPeers()
    console.log('roomIdroomIdroomIdroomIdroomIdroomId加入对讲', roomId)
    noticeHelmetMeet(helmetList, roomId)
  }
  store.commit('openWaike', true)
}

async function noticeHelmetMeet(helmetList, roomId) {
  if (_peers) {
    //自己先加入房间，因头盔无法加入用户数为0的房间
    if (roomId && !g_is_meeting) {
      await joinRoomSoup(roomId)
    }
    var sendMsg = {
      content: {
        cmd: 'GROUP_CHAT',
        code: '000',
        params: {
          // 发起对讲时时用helmetlist
          helmetList: helmetList,
          roomId: roomId,
          fromUser: getSession('username'),
        },
      },
      header: {
        from: getSession('userId'),
        to: 'SYS',
        requireResponse: false,
      },
    }
    CHAT.chat(websocketapp.WALKIE, '', sendMsg)
    getRoomPeers()
  }
}

/**
 * 退出全部房间
 * @param {*} currenData 当前房间用户数据
 * @param {*} isEnterRoom 是否接通
 */
function exitRemoteRoom(currenData, isEnterRoom) {
  console.log('currenData, isEnterRoom', currenData, isEnterRoom)
  store.commit('openWaike', false)
  // 处理除去本身列表
  let helmetList = []
  let userList = currenData.userList
  let userId = getSession('userId')
  for (var i = 0; i < userList.length; i++) {
    if (userId !== userList[i].userId) {
      helmetList.push(userList[i].helmetId)
    }
  }
  // (1是拨通后挂断，2是未拨通挂断)
  let hangUp = ''
  if (isEnterRoom) {
    hangUp = '1'
  } else {
    hangUp = '2'
  }
  var sendMsg = {
    content: {
      cmd: 'GROUP_CHAT',
      code: '000',
      params: {
        // 挂断对讲时用to
        to: helmetList,
        hangUp: hangUp,
      },
    },
    header: {
      from: getSession('userId'),
      to: 'SYS',
      requireResponse: false,
    },
  }

  CHAT.chat(websocketapp.WALKIE, '', sendMsg)
  _consumers.forEach(function(consu) {
    consu.close()
  })
  _consumers.clear()
  consumeredProduIds.clear()
}

export { loginWalkie, joinRoomSoup, helmetJoinSoup, exitRemoteRoom, closeResetMeet, outClose }
